<template lang="pug">
//- 今日推薦
.course-item(
  @click="$root.enterCourse(course.course_id)",
  v-bind:class="course.course_lang === 'en' ? 'bg-purple' : course.course_lang === 'ja' ? 'bg-orange' : 'bg-green'"
)
  .course-item-title {{ course.title }}
  //- .course-item-info {{ course.info }}
  .course-item-teacher {{ course.coures_teacher.name }}
  .course-item-time
    img(src="@/assets/images/start.png")
    span {{ course.start_time }}
</template>
<script>
export default {
  name: 'courseItem',
  props: ['course'],
  components: {

  },
  data () {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang="sass" scoped>
.bg-purple
  background: #cceafb
.bg-green
  background: #e7bbfc
.bg-orange
  background: #fadbe8
</style>
